var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"label":_vm.label,"items":_vm.select_choices,"value":_vm.value},on:{"change":_vm.onChange}}),_c('div',{staticStyle:{"padding-left":"15px","padding-right":"15px"}},[_c('b',[_vm._v(_vm._s(_vm.label)+" Text: ")]),_vm._v(" "+_vm._s(_vm.agreement_text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }